import React, { useEffect, useRef, useState } from 'react';
import { Await, json, useNavigate } from 'react-router-dom';
import { MODULE_TYPES } from '@ohif/core';
import filesToStudies from './filesToStudies';
import { extensionManager } from '../../App.tsx';
import { ProgressBar } from 'primereact/progressbar';
import classNames from 'classnames';
import axios from 'axios';
import { filter, forEach } from 'lodash';
import dicomParser from 'dicom-parser';
import { ImagemService } from '../../service/ImagemService.js';
import { LoadingIndicatorProgress } from '@ohif/ui';
import { Toast } from 'primereact/toast';

window.axios = axios;

window.GblVar = {
  SerieActive: "",
  InitLoadImages: false,
  ListSeries: [],
  SeriesCarregadas: [],
  ListIntancesBySeries: [{ Serie: "", Number: "" }]
};


let startDownloadS3 = false;
let instanceCountBySerie = [];

function Local() {
  const navigate = useNavigate();
  const [start, setStart] = useState<boolean>(false);
  const [isS3, setIsS3] = useState<boolean>(false);
  const [compProgress, setCompProgress] = useState(<div></div>);

  const toastRef = useRef(null);

  // Initializing the dicom local dataSource
  const dataSourceModules = extensionManager.modules[MODULE_TYPES.DATA_SOURCE];
  const localDataSources = dataSourceModules.reduce((acc, curr) => {
    const mods = [];
    curr.module.forEach(mod => {
      if (mod.type === 'localApi') {
        mods.push(mod);
      }
    });
    return acc.concat(mods);
  }, []);
  const firstLocalDataSource = localDataSources[0];
  const dataSource = firstLocalDataSource.createDataSource({});

  window.GblVar.InitLoadImages = false;

  const atualizarCountThumb = () => {
    const tmInterval = setInterval(() => {
      const isRendered = cornerstone.getEnabledElements().length > 0;
      if (isRendered) {
        clearInterval(tmInterval);
        instanceCountBySerie.forEach(obj => {
          const elState = document.getElementById(`SN-${obj.seriesNumber}`);
          if (elState)
            elState.innerText = obj.count;
        });
      }
    }, 200);
  }

  const validarUrlImagekey = (urlRedir) => {
    let param = "";
    const arrParam = window.location.search.split('&');
    if (arrParam.length > 1) {
      for (let index = 1; index < arrParam.length; index++) {
        const item = arrParam[index];
        param += `&${item}`;
      }
    }
    return urlRedir + param;
  }

  const onDrop = async (acceptedFiles, enabledVPElement) => {
    const studies = await filesToStudies(acceptedFiles, enabledVPElement);
    // Todo: navigate to work list and let user select a mode
    if (location.href.indexOf('dicom') === -1) {
      window.GblVar.InitLoadImages = true;
      const query = new URLSearchParams();
      studies.forEach(id => query.append('StudyInstanceUIDs', id));
      AdicionarBotoesParaVisualizarRelatorioSR(); // (DEV-3539)
      let urlRedir = validarUrlImagekey(`/viewer/dicom?${decodeURIComponent(query.toString())}`);

      if (window.config.TokenMode) {
        const token = window.Token;
        if (token) {
          urlRedir = validarUrlImagekey(`/viewer/dicom?token=${token}`);
        }
      }
      navigate(urlRedir);
    }
  };

  window.onDrop = async (acceptedFiles, enabledVPElement) => { await onDrop(acceptedFiles, enabledVPElement) };

  //IMPLEMENTADO (DEV-2763)
  const objGetUrl = () => {
    return {
      CountFiles: 0,
      TotalFiles: 0,
      BlobArr: [],
      Path: "0",
      Url: "",
      Index: 0, // Utilizado no 'FOR' Para retornar 100 imagens por vez
      CountProgress: 1,
      Finally: false,
      Serie: "0",
      FirstSerie: "0"
    }
  }

  const getImagesService = async (obj) => {
    try {

      if (obj === null || obj === undefined)
        obj = objGetUrl();

      if (obj.OnDrop === undefined) {
        if (obj) {
          if (window.GblVar.SeriesCarregadas.length === 1 && window.GblVar.SeriesCarregadas[0].Serie === obj.Serie)
            return;
          window.GblVar.SerieActive = obj.Serie;
        }
      }

      const serieJaCarregada = window.GblVar.SeriesCarregadas.some(item => item.Serie === obj.Serie);
      if (serieJaCarregada)
        return;

      if (obj.Serie !== window.GblVar.SerieActive)
        obj = objGetUrl();
      obj.Serie = window.GblVar.SeriesCarregadas.length === 0 ? "0" : window.GblVar.SerieActive;
      if (obj.Serie === "")
        return;

      if (obj.Serie === imageBySerieInProgress && obj.Index === undefined)
        return;

      imageBySerieInProgress = obj.Serie;

      obj.FirstSerie = window.GblVar.SeriesCarregadas.length > 0 ? "1" : "0";
      obj.Index = obj.Index === undefined ? "0" : obj.Index;
      obj.Url = `${getUrlApi()}/${studyUId}/firstSerie/${obj.FirstSerie}/index/${obj.Index}/serie/${obj.Serie}`;
      obj.BlobArr = obj.BlobArr === undefined ? [] : obj.BlobArr;
      try {
        const response = await axios.get(obj.Url);
        if (response) {
          const data = response.data;
          if (data.listInstances.length === 0) {
            if (obj.Serie && obj.Serie !== "0") {
              window.GblVar.SeriesCarregadas.push({ Serie: obj.Serie, Number: data.instanceCountBySerie });
              window.GblVar.ListIntancesBySeries.push({ Serie: obj.Serie, Blob: [] });
            }
            getImgsDCMBySerie();
            return;
          }
          obj.CountFiles = 0;
          obj.TotalFiles = data.listInstances.length;
          await Promise.all(data.listInstances.map(async (fileB64) => {
            if (obj.CountFiles < obj.TotalFiles + 1) {
              const base64Response = await fetch(`data:application/dcm;base64,${fileB64}`);
              const blob = await base64Response.blob();
              obj.BlobArr.push(blob);
            }
            obj.CountFiles++;
            if (isS3)
              window.setMsgPercentProgress(`${obj.CountFiles} de ${data.totalFiles}`);
          }));
          obj.Index = data.index;
          obj.Path = btoa(data.path);
          obj.TotalFiles = data.totalFiles;
          const baixados = obj.BlobArr.length;
          const calcBaixados = Math.round(obj.TotalFiles - baixados);
          obj.Finally = calcBaixados - 1 <= 0;
          if (obj.Finally && obj.BlobArr.length > 0) {
            if (obj.Preload) {
              window.GblVar.ListIntancesBySeries.push({ Serie: obj.Serie, Blob: obj.BlobArr });
              window.GblVar.SeriesCarregadas.push({ Serie: obj.Serie, Number: data.seriesNumber });
              getImgsDCMBySerie();
            } else {
              instanceCountBySerie = data.instanceCountBySerie;
              if (data.instanceCountBySerie) {
                data.instanceCountBySerie.sort((a, b) => a.seriesNumber - b.seriesNumber);
                window.GblVar.SeriesCarregadas.push({
                  Serie: data.instanceCountBySerie[0].serieUid,
                  Number: data.instanceCountBySerie[0].seriesNumber
                });
                onDrop(obj.BlobArr);
              }
            }
          }
          else {
            getImagesService(obj);
          }
        }
      } catch (error) {
        console.error('Erro ao fazer a requisição:', error);
      }
    } catch (error) {
      console.error(error);
    }
  }

  window.getImagesService = (param) => getImagesService(param);

  const addInstancesBySeries = async (serie) => {
    const objSerie = window.GblVar.ListIntancesBySeries.filter(obj => obj.Serie === serie)[0];
    if (objSerie) {
      if (objSerie.Completed)
        return;
    }
    if (window.GblVar.SeriesCarregadas.some(item => item.Serie === serie) === false) {
      //window.GblVar.SeriesCarregadas.push({ Serie: serie });
      getImagesService({ Serie: serie, OnDrop: true });
    } else {
      if (window.GblVar.ListIntancesBySeries.length > 0) {
        const viewport = cornerstone.getEnabledElements()[viewportIndexOnFocus];
        if (viewport) {
          if (objSerie) {
            objSerie.Completed = true;
            onDrop(objSerie.Blob);
          } else {
            window.GblVar.SerieActive = serie;
            getImagesService({ Serie: serie });
          }
        }
      }
    }
  }

  window.addInstancesBySeries = (serie) => addInstancesBySeries(serie);

  function getImgsDCMBySerie() {
    const tm = setInterval(async () => {
      if (cornerstone.getEnabledElements()[viewportIndexOnFocus]) {
        let seriesCarregadas = window.GblVar.SeriesCarregadas;
        if (seriesCarregadas.length > 0) {
          clearInterval(tm);
          seriesCarregadas.sort((a, b) => a.Number - b.Number);
          const primeiraSerieJaCarregada = seriesCarregadas[0].Serie;
          const listSeries = window.GblVar.ListSeries.sort((a, b) => a.Number - b.Number);
          for (let index = 0; index < listSeries.length; index++) {
            const serie = listSeries[index].Serie;
            if (serie !== primeiraSerieJaCarregada) {
              const serieNaoCarregada = seriesCarregadas.some(item => item.Serie === serie) === false;
              if (serieNaoCarregada) {
                //getImagesService({ Serie: serie, Preload: true });
                await window.getImagesDicomOnClickSerie({ Serie: serie, Preload: true });
                break;
              }
            }
          }
        }
      }
    }, 1000);
  }

  window.getImgsDCMBySerie = () => { getImgsDCMBySerie(); }

  const initDownloadS3 = () => {
    if (window.config.TokenMode) {
      studyUId = window.studyUIdToken;
    }
    
    if (startDownloadS3 === false) {
      const imagemService = new ImagemService();
      startDownloadS3 = true;
      imagemService.startDownloadS3(studyUId);
      setCompProgress(<LoadingIndicatorProgress className="h-full w-full bg-black" isS3={true} />);
    }
  }
  const getIsS3 = async () => {

    if (window.config.TokenMode) {
      studyUId = await new Promise((resolve, reject) => {
        let attempts = 0;
        let interval = setInterval(() => {
          if (window.studyuid !== undefined && window.studyuid !== null && window.studyuid !== "") {
            clearInterval(interval);
            resolve(window.studyuid); // retorna o valor
          } else {
            attempts++;
            if (attempts >= 60) {
              clearInterval(interval);
              reject(new Error("studyuid não foi preenchido após 60 tentativas"));
            }
          }
        }, 1000);
      }).catch(err => {
        console.warn(err.message);
        return null;
      });
    }

    const imagemService = new ImagemService();
    const isS3 = await imagemService.getIsS3(studyUId === null || studyUId === undefined ? window.studyuid : studyUId);
    if (isS3) {
      setIsS3(true);
      initDownloadS3();
    } else {
      setIsS3(false);
      //getImagesService(null);
      setCompProgress(<LoadingIndicatorProgress className="h-full w-full bg-black" isS3={false} />);
      getImagesDicomInit().then((result) => {
        if (result === 0)
          toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: 'Imagens não liberadas ou não encontradas.', life: 200000 });
      });
    }
  }

  useEffect(() => {
    if (start === false) {
      setStart(true);
      getIsS3();
    }
  }, [start])

  return (
    <div><Toast ref={toastRef} />{compProgress}</div>
  );
}

try {
  const urlParams = new URLSearchParams(window.location.search);
  const studyUID = urlParams.get('StudyInstanceUIDs');
  if (studyUID) {
    window.studyuid = studyUID;
  }

  const metaDataDisable = window.config.metaDataDisable;
  if (metaDataDisable) {
    let completed = sessionStorage.getItem('completed');
    const urlContainStudyInstanceUIDs = window.location.search.split("?StudyInstanceUIDs").length == 2;
    const urlContainTmtv = window.location.href.includes('tmtv');
    if (completed) {
      sessionStorage.removeItem('completed');
      if (urlContainStudyInstanceUIDs && !urlContainTmtv)
        window.location.href = window.location.href.replace("viewer/dicom?StudyInstanceUIDs=", "study?");
    } else {
      sessionStorage.setItem('completed', '1');
      if (urlContainStudyInstanceUIDs && !urlContainTmtv)
        window.location.href = window.location.href.replace("viewer?StudyInstanceUIDs=", "study?");
    }
  }

  if (window.config.TokenMode && window.location.href.includes("/dicom?token=")) {
    window.location.href = window.location.href.replace("/viewer/dicom?token=", "/study?token=");
  }
} catch (ex) {
  console.error(ex);
}

export default Local;
